import * as Sentry from '@sentry/nextjs'
import { buildAxiosInstance } from '../../../../../utils/apiUtils'

export async function apiExecuteSignOut (): Promise<void> {
  try {
    await buildAxiosInstance().post<Response>('/api/auth/sign_out')
  } catch (e) {
    if (e instanceof Error) {
      Sentry.captureMessage(`An issue occurred when signing out the user: ${e.message} `)
    }
  }
}
